import * as React from 'react';
import './styles/MenuListDevider.scss';

const MenuListDevider: React.FC = () => {
  return <div className="menu-list-devider"></div>;
};

export default MenuListDevider;
